import { all, takeLatest, call, put } from "redux-saga/effects";

import {
  setListCredentialsSuccess,
  getTypeCredentialSuccess,
  setQuotaCredentialSuccess,
  setCredentialScheduleSuccess,
  setCredentialScheduleAvailablePlaces,
  setCredentialScheduleAvailableDates,
  setCredentialScheduleAvailableTimes,
} from "./actions";
import { changeProfileExhibitorSuccess } from "../profile/actions";
import {
  getListCredentialsService,
  getCollaboratorOfContractService,
  getCredentialService,
  handleAssociateCredentialService,
  updateAssociateCredentialService,
  removeAssociateCredentialService,
  getCredentialsQuotaService,
  getCredentialScheduleService,
  editCredentialScheduleService,
  postCredentialScheduleService,
  deleteCredentialScheduleService,
  getCredentialScheduleAvailablePlacesService,
  getCredentialScheduleAvailableDatesService,
  getCredentialScheduleAvailableTimesService,
} from "../../../service/credentials.service";

function* getListCredentials({ payload }) {
  try {
    const response = yield call(getListCredentialsService, payload.params);

    if (response.status === 200) {
      yield put(setListCredentialsSuccess(response.data.credentialOutputList));
      payload.callbackPaginationInfo(response.data.paginationInfo);
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* getCollaboratorOfContract({ payload }) {
  try {
    const response = yield call(
      getCollaboratorOfContractService,
      payload.params
    );

    if (response.status === 200) {
      payload.callbackSuccess(response.data.output);
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* getCredential({ payload }) {
  try {
    const response = yield call(getCredentialService, payload.id);

    if (response.status === 200) {
      payload.callbackSuccess(response.data.credentialOutput);
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* handleAssociateCredential({ payload }) {
  try {
    const response = yield call(handleAssociateCredentialService, payload.data);

    if (response.status === 200) {
      getListCredentials(
        {
          opportunity_id: payload.data.opportunityId,
          event_id: payload.data.eventId,
          search: "",
        },
        payload.callbackError
      );

      payload.callbackSuccess();
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* updateAssociateCredential({ payload }) {
  try {
    const response = yield call(updateAssociateCredentialService, payload.data);

    if (response.status === 200) {
      getListCredentials(
        {
          opportunity_id: payload.data.opportunityId,
          event_id: payload.data.eventId,
          search: "",
        },
        payload.callbackError
      );

      payload.callbackSuccess();
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* deleteAssociateCredential({ payload }) {
  try {
    const response = yield call(removeAssociateCredentialService, payload.id);

    if (response.status === 200) {
      payload.callbackSuccess(response.data.code);
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* getQuotaCredential({ payload }) {
  try {
    const response = yield call(getCredentialsQuotaService, payload.params);

    if (response.status === 200) {
      yield put(
        setQuotaCredentialSuccess(response.data.credentialSumQuotaOutput)
      );
      yield put(
        getTypeCredentialSuccess(response.data.credentialCategoryOutputList)
      );
      yield put(
        changeProfileExhibitorSuccess(response.data.companyNameCredential)
      );
      payload.callbackQuotaInfo();
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  } finally {
  }
}

function* getCredentialSchedule({ payload }) {
  const { event, opportunity } = payload;
  try {
    const response = yield call(
      getCredentialScheduleService,
      event,
      opportunity
    );
    if (response.status === 200) {
      yield put(
        setCredentialScheduleSuccess(response.data.credentialScheduleOutputList)
      );
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* postCredentialSchedule({ payload }) {
  const { params } = payload;
  try {
    const response = yield call(postCredentialScheduleService, params);
    if (response.status === 200) {
      payload.callbackSuccess(response.data.code);
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* editCredentialSchedule({ payload }) {
  const { params, id } = payload;
  try {
    const response = yield call(editCredentialScheduleService, params, id);
    if (response.status === 200) {
      payload.callbackSuccess(response.data.code);
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* deleteCredentialSchedule({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(deleteCredentialScheduleService, id);
    if (response.status === 200) {
      payload.callbackSuccess(response.data.code);
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* getCredentialScheduleAvailablePlaces({ payload }) {
  try {
    const response = yield call(
      getCredentialScheduleAvailablePlacesService,
      payload.params
    );

    if (response.status === 200) {
      yield put(
        setCredentialScheduleAvailablePlaces(
          response.data.placeSelectOutputList
        )
      );
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* getCredentialScheduleAvailableDates({ payload }) {
  try {
    const response = yield call(
      getCredentialScheduleAvailableDatesService,
      payload.params
    );

    if (response.status === 200) {
      yield put(
        setCredentialScheduleAvailableDates(
          response.data.dateTimeSelectOutputList
        )
      );
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

function* getCredentialScheduleAvailableTimes({ payload }) {
  try {
    const response = yield call(
      getCredentialScheduleAvailableTimesService,
      payload.params
    );

    if (response.status === 200) {
      yield put(
        setCredentialScheduleAvailableTimes(
          response.data.dateTimeSelectOutputList
        )
      );
    }
  } catch (error) {
    payload.callbackError(error.response.data.code);
  }
}

export default all([
  takeLatest("GET_LIST_CREDENTIALS", getListCredentials),
  takeLatest("GET_COLLABORATOR_OF_CONTRACT", getCollaboratorOfContract),
  takeLatest("GET_CREDENTIAL", getCredential),
  takeLatest("HANDLE_ASSOCIATE_CREDENTIAL", handleAssociateCredential),
  takeLatest("UPDATE_ASSOCIATE_CREDENTIAL", updateAssociateCredential),
  takeLatest("DELETE_ASSOCIATE_CREDENTIAL", deleteAssociateCredential),
  takeLatest("GET_QUOTA_CREDENTIAL", getQuotaCredential),
  takeLatest("GET_CREDENTIAL_SCHEDULE", getCredentialSchedule),
  takeLatest("POST_CREDENTIAL_SCHEDULE", postCredentialSchedule),
  takeLatest("EDIT_CREDENTIAL_SCHEDULE", editCredentialSchedule),
  takeLatest("DELETE_CREDENTIAL_SCHEDULE", deleteCredentialSchedule),
  takeLatest(
    "GET_CREDENTIAL_SCHEDULE_AVAILABLE_PLACES",
    getCredentialScheduleAvailablePlaces
  ),
  takeLatest(
    "GET_CREDENTIAL_SCHEDULE_AVAILABLE_DATES",
    getCredentialScheduleAvailableDates
  ),
  takeLatest(
    "GET_CREDENTIAL_SCHEDULE_AVAILABLE_TIMES",
    getCredentialScheduleAvailableTimes
  ),
]);
